export const base = {
  "rings": [
    "adopt",
    "trial",
    "assess",
    "hold",
    "retire"
  ],
  "showEmptyRings": false,
  "homepageContent": "both",
  "quadrantsMap": {
    "quadrant1": {
      "colour": "#A371E5",
      "txtColour": "#444444",
      "position": 1,
    },
    "quadrant2": {
      "colour": "#52B0EB",
      "txtColour": "white",
      "position": 2,
    },
    "quadrant3": {
      "colour": "#F0D77F",
      "txtColour": "#444444",
      "position": 3,
    },
    "quadrant4": {
      "colour": "#DE6359",
      "txtColour": "white",
      "position": 4,
    }
  },
  "chartConfig": {
    "size": 800,
    "scale": [
      -19,
      19
    ],
    "blipSize": 12,
    "ringsAttributes": [
      {
        "radius": 8,
        "arcWidth": 6
      },
      {
        "radius": 11,
        "arcWidth": 4
      },
      {
        "radius": 14,
        "arcWidth": 2
      },
      {
        "radius": 16,
        "arcWidth": 2
      }
      ,
      {
        "radius": 19,
        "arcWidth": 3
      }
    ],
    "editLink": {
      "radarLink": "https://github.com/AOEpeople/techradar/edit/main/radar",
      "title": "Edit"
    }
  },
  "dateFormat": "MMMM YYYY"
}
